angular.module('qkr')
    .controller('MasterCardAdminController', function($scope, feedbackService, messageService, checkBrowserService,
                                                      $uibModal, appConfig, usSpinnerService, partnerService,
                                                      merchantService, sessionService, subscriptionService,
                                                      utils, $window, APP_CONSTANT, $log, $timeout) {
    const mastercardCtrl = this;

    // important this need to be manage well if not the page won't display
    mastercardCtrl.loading = false;

    mastercardCtrl.feedbacks = [];
    mastercardCtrl.displayUnsupportedBrowserAlert = appConfig.displayUnsupportedBrowserAlert;
    mastercardCtrl.username = appConfig.username;
        mastercardCtrl.isMCAdmin = appConfig.isMCAdmin;
    mastercardCtrl.showPartnerReport = false;
    mastercardCtrl.showDirectKeys = false;


    const loadMerchantAndSetSession = () => {
        subscriptionService.subscribeAction(APP_CONSTANT.SubscriptionService.ADD_SPINNER, () => {
            $scope.isSpinnerVisible = true;
            usSpinnerService.spin('spinner-1');
        });
        subscriptionService.executeAction(APP_CONSTANT.SubscriptionService.ADD_SPINNER);
        // set the merchant in the session to redirection
        merchantService.loadMerchant(sessionService.getMerchantSessionId())
            .then(() => {
                const fullUrl = sessionService.getLastUrlVisited();
                $window.location.href = fullUrl;
                subscriptionService.executeAction(APP_CONSTANT.SubscriptionService.REMOVE_SPINNER);
            }).catch(reason => {
                $log.error(reason);
            });
    }

    const init = function() {
        const messageSessionExpired =
            utils.getParameterUrl($window.location.search, 'sessionExpiredMessage');
        subscriptionService.subscribeAction(APP_CONSTANT.SubscriptionService.ADD_PARTNER_REPORT, () => {
            mastercardCtrl.showPartnerReport = true;
        });
        if (messageSessionExpired &&
            messageSessionExpired.sessionExpiredMessage &&
            sessionService.getMerchantSessionId() &&
            sessionService.getLastUrlVisited()) {
            mastercardCtrl.loading = true;
            $timeout(() => {
                // this only to make sure it will display the view! if something goes wrong
                mastercardCtrl.loading = false;
            }, 3000);
            loadMerchantAndSetSession();
        }

        if (appConfig.isPartner) {
            partnerService.getCurrentPartner().then(partner => {
                if (partner.apiType && partner.apiType === 'OPEN_API') {
                    mastercardCtrl.showDirectKeys = false;
                } else {
                    mastercardCtrl.showDirectKeys = true;
                }
            })
        }

        if (mastercardCtrl.displayUnsupportedBrowserAlert) {
            if (checkBrowserService.isUnsupportedBrowser()) {
                $uibModal.open({
                    template: require('../../templates/browserAlertDialog.html'),
                    controller: 'BrowserAlertController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {}
                });
            }
        }
    };

    mastercardCtrl.loadFeedbacks = function() {
        // TODO the same code is in feedback.list.controller and page,
        // for use the same page it need make some changes in this mastercardCtrlAdmin.gsp and main.js
        $scope.tab = 'feedbacks';

        feedbackService.loadAll().then((promise) => {
                messageService.log('feedbacks', promise);
                $scope.feedbacks = promise;
            },
            (promise) => {
                messageService.log('error...', promise);
            }
        );
    };

    mastercardCtrl.feedbackDetail = function(index) {
        const params = [$scope.feedbacks[index].description, $scope.feedbacks[index].pagName, $scope.feedbacks[index].merchant.name];
        utils.modalInstanceFeedback(params);
    };

    init();
});



// WEBPACK FOOTER //
// ./src/controllers/mastercard/mastercard.admin.controller.js